










import Vue from 'vue'
import Avatar from '@/components/Avatar/avatar.vue'
import Student from '@/models/Students/Student'

export default Vue.extend({
  name: 'PatientIndexColumn',
  components: {Avatar},
  props: {
    scope: Object as () => {
      pagination: {
        pageSize: number
        currentPage: number
        totalItems: number
      }
    },
    rowIndex: Number,
    toggleRowDetail: Function,
    row: Object as () => Student,
  },
  computed: {
    recordNumber (): number {
      return this.scope.pagination.currentPage * this.scope.pagination.pageSize - this.scope.pagination.pageSize + this.rowIndex + 1
    }
  }
})
